import Component from '@glimmer/component';
import { action } from '@ember/object';
import { htmlSafe } from '@ember/template';

export default class PaperDataTableColumn extends Component {
  get active() {
    return this.args.sortProp && this.args.sortProp === this.args.currentProp;
  }

  get style() {
    let width = this.args.width;
    if (width) {
      return htmlSafe(`width: ${Number(width)}px;`);
    }
    return undefined;
  }

  @action
  handleClick() {
    let sortProp = this.args.sortProp;
    if (!sortProp) {
      return;
    }

    let sortDir = this.args.sortDir;
    let newSortDir;
    if (!this.active) {
      newSortDir = 'asc';
    } else {
      newSortDir = sortDir === 'asc' ? 'desc' : 'asc';
    }

    this.args.sortChanged(sortProp, newSortDir);
  }
}
